import {
  CaretDownFilled,
  CaretUpFilled,
  FormOutlined,
} from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";

import styles from "./styles/panelheader.module.css";
import { COLORS } from "../../../constants";

const { Paragraph } = Typography;
const Panelheader = ({
  _index,
  _title,
  _activekeys = [],
  _isEditingValue,
  isAdmin,
  _isEditing = () => {},
}) => {
  const [isActive, setisActive] = useState(false);
  useEffect(() => {
    if (_activekeys.includes(_index.toString())) {
      setisActive(true);
    } else {
      setisActive(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_activekeys]);

  return (
    <Row align="middle" justify="space-between" style={{ width: "100%" }}>
      <Col span={isAdmin ? 22 : 24}>
        <div
          style={{
            border: `1px solid ${isActive ? COLORS.blue1 : COLORS.brown1}`,
            padding: "15px 0 7px 20px",
            backgroundColor: "#B3C8CD",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Paragraph>{_title}</Paragraph>

          {isActive ? (
            <CaretUpFilled className={styles.caret} />
          ) : (
            <CaretDownFilled className={styles.caret} />
          )}
        </div>
      </Col>
      {isAdmin && (
        <Col span={2}>
          <FormOutlined
            onClick={() => {
              if (!_isEditingValue && !isActive) _isEditing();
            }}
            style={{
              marginLeft: 10,
              fontSize: 30,
              color: _isEditingValue ? COLORS.blue1 : "inherit",
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default Panelheader;
